/**
 * GroupChatPage - Real-time group chat for community members.
 * Access requires a completed application.
 */

import { GroupChatProvider, GroupChatView } from '../features/group-chat'

export function GroupChatPage() {
  return (
    <GroupChatProvider>
      <GroupChatView />
    </GroupChatProvider>
  )
}
